import {
  tradeDateRange,
  eimEntityCoordinatorListWithTagbox,
  oasisSnapshotIndicator,
} from '@/components/Ciso/BaseStore/CisoConfigs';

export default {
  dockConfig: {
    alignment: 'LEFT',
    visible: false,
  },
  searchFilterConfig: {
    tradeDateRange,
    eimEntity: { ...eimEntityCoordinatorListWithTagbox, type: 'select', required: true },
    inputTimeType: {
      label: 'Input Time Type',
      value: 'ALL',
      type: 'select',
      options: [
        { label: 'ALL', value: 'ALL' },
        { label: 'T-40', value: 'T-40' },
        { label: 'T-55', value: 'T-55' },
        { label: 'T-75', value: 'T-75' },
      ],
    },
    marketType: {
      label: 'Market Type',
      value: 'ALL',
      type: 'select',
      options: [
        { label: 'ALL', value: 'ALL' },
        { label: 'DAM', value: 'DAM' },
        { label: 'RTM', value: 'RTM' },
      ],
    },
  },
  fields: [
    {
      label: 'TRADING DATE',
      dataType: 'date',
      prop: 'tradingDate',
      width: 100,
      filterable: true,
      sortable: true,
      visible: true,
      sortIndex: 0,
      sortOrder: 'asc',
    }, {
      label: 'EIM ENTITY',
      dataType: 'string',
      prop: 'eimEntity',
      width: 100,
      filterable: true,
      sortable: true,
      visible: true,
      sortIndex: 1,
      sortOrder: 'asc',
    }, {
      label: 'MARKET TYPE',
      dataType: 'string',
      prop: 'marketType',
      width: 100,
      filterable: true,
      sortable: true,
      visible: true,
      sortIndex: 2,
      sortOrder: 'asc',
    }, {
      label: 'INPUT TIME TYPE',
      dataType: 'string',
      prop: 'inputTimeType',
      width: 110,
      filterable: true,
      sortable: true,
      visible: true,
      sortIndex: 4,
      sortOrder: 'asc',
    }, {
      label: 'Hour Ending',
      dataType: 'number',
      prop: 'hourEnding',
      width: 100,
      filterable: true,
      sortable: true,
      visible: true,
      sortIndex: 3,
      sortOrder: 'asc',
    }, {
      label: 'BAA',
      dataType: 'string',
      prop: 'baa',
      width: 100,
      filterable: true,
      sortable: true,
      visible: true,
      sortIndex: 5,
      sortOrder: 'asc',
    }, {
      label: 'TEST RESULT',
      dataType: 'string',
      prop: 'testResult',
      width: 100,
      filterable: true,
      sortable: true,
      visible: true,
      sortIndex: 6,
      sortOrder: 'asc',
    }, {
      label: 'CONSTRAINT TYPE',
      dataType: 'string',
      prop: 'constraintType',
      width: 200,
      filterable: true,
      sortable: true,
      visible: true,
    }, {
      label: 'CONSTRAINT NAME',
      dataType: 'string',
      prop: 'constraintName',
      width: 200,
      filterable: true,
      sortable: true,
      visible: true,
    }, {
      label: 'DIRECTION',
      dataType: 'string',
      prop: 'direction',
      width: 100,
      filterable: true,
      sortable: true,
      visible: true,
    }, {
      label: 'FLOWGATE STATION',
      dataType: 'string',
      prop: 'flowgateStation',
      width: 200,
      filterable: true,
      sortable: true,
      visible: true,
    }, {
      label: 'CURVE ID',
      dataType: 'number',
      prop: 'curveId',
      width: 100,
      filterable: true,
      sortable: true,
      visible: true,
    }, {
      label: 'SEGMENT ID',
      dataType: 'number',
      prop: 'segmentId',
      width: 100,
      filterable: true,
      sortable: true,
      visible: true,
    }, {

      label: 'VIOLATION [%]',
      dataType: 'number',
      width: 200,
      filterable: true,
      sortable: true,
      visible: true,
      format: {
        type: 'percent',
        precision: 2,
      },
      calculateCellValue: (row) => row.violationPercentage / 100.0,
    }, {
      label: 'VIOLATION AMOUNT [MW]',
      dataType: 'number',
      prop: 'violationAmount',
      width: 200,
      filterable: true,
      sortable: true,
      visible: true,
    },
  ],
  options: {
    exportExcel: true,
    filterRow: true,
    filterHeader: true,
    columnConfig: true,
    showSelectFilter: false,
  },
};